<div class="mt-modal blur" [ngClass]="variant">
  <div class="modal-container">
    <div class="modal-content">
      <div class="modal-header">
        <mt-h3 class="modal-title">
          {{ title }}
        </mt-h3>
        <span class="sp"></span>
        <mt-btn class="icon error" (onAction)="onClickAction(false)">
          <mat-icon>clear</mat-icon>
        </mt-btn>
      </div>
      @if (!contentbody) {
        <div class="modal-body" >
          <ng-content></ng-content>
        </div>
      }
      <div class="modal-footer">
        @for (btn of buttons; track btn) {
          <mt-btn
            [class]="btn.class"
            [id]="btn.label"
            (onAction)="onClickAction(btn.submit)"
            [disabled]="disabled || btn.disabled"
            >
            {{ btn.label }}
          </mt-btn>
        }
      </div>
    </div>
  </div>
</div>
